import { combineEpics, ofType } from 'redux-observable'
import { of } from 'rxjs'
import { catchError, map, mergeMap, takeUntil } from 'rxjs/operators'

import {
  ADD_LANDING_PAGE_ASYNC,
  EDIT_LANDING_PAGE_ASYNC,
  GET_LANDING_PAGE_ASYNC,
} from './constants'

const getLandingPageBody = (state, action) => ({
  landing_page_content: {
    content: state.awarenessCenter.landingPageForm.landingPage.content,
    page_title: state.awarenessCenter.landingPageForm.landingPage.title,
    locale: state.awarenessCenter.landingPageForm.landingPage.locale,
  },
  name: state.awarenessCenter.landingPageForm.landingPage.name,
  training_type: state.awarenessCenter.landingPageForm.landingPage.trainingType,
  force_save: action.payload?.forceSave || false,
})

const editLandingPageEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(EDIT_LANDING_PAGE_ASYNC.INITIATE),
    mergeMap((action) =>
      api.awarenessCenter
        .editLandingPage(
          action.payload.id,
          getLandingPageBody(state$.value, action),
          state$.value.partnerOptions.selectedCompany?.value,
          !!state$.value.app.data.partner
        )
        .pipe(
          map((response) =>
            EDIT_LANDING_PAGE_ASYNC.onSuccess({
              data: response,
            })
          ),
          catchError((error) =>
            of(epicsErrorHandler(EDIT_LANDING_PAGE_ASYNC.onError, error, [400]))
          ),
          takeUntil(action$.pipe(ofType(EDIT_LANDING_PAGE_ASYNC.CANCEL)))
        )
    )
  )

const addLandingPageEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(ADD_LANDING_PAGE_ASYNC.INITIATE),
    mergeMap((action) =>
      api.awarenessCenter
        .addLandingPage(
          getLandingPageBody(state$.value, action),
          state$.value.partnerOptions.selectedCompany?.value,
          !!state$.value.app.data.partner
        )
        .pipe(
          map(() => ADD_LANDING_PAGE_ASYNC.onSuccess()),
          catchError((error) =>
            of(epicsErrorHandler(ADD_LANDING_PAGE_ASYNC.onError, error, [400]))
          ),
          takeUntil(action$.pipe(ofType(ADD_LANDING_PAGE_ASYNC.CANCEL)))
        )
    )
  )

const getLandingPageEpic = (action$, state$, { api, epicsErrorHandler }) =>
  action$.pipe(
    ofType(GET_LANDING_PAGE_ASYNC.INITIATE),
    mergeMap((action) =>
      api.awarenessCenter
        .getLandingPage(
          action.payload.id,
          state$.value.partnerOptions.selectedCompany?.value,
          !!state$.value.app.data.partner
        )
        .pipe(
          map((response) =>
            GET_LANDING_PAGE_ASYNC.onSuccess({
              landingPage: response,
            })
          ),
          catchError((error) => of(epicsErrorHandler(GET_LANDING_PAGE_ASYNC.onError, error))),
          takeUntil(action$.pipe(ofType(GET_LANDING_PAGE_ASYNC.CANCEL)))
        )
    )
  )

export default combineEpics(getLandingPageEpic, addLandingPageEpic, editLandingPageEpic)
